"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Typography = void 0;

var _stylitas = require("@creditas/stylitas");

var _typography = require("./typography.style");

var _customizations = require("./customizations.style");

const Typography = _stylitas.styled.span`
  ${_typography.typographyBase};
  ${_typography.typographyH1};
  ${_typography.typographyH2};
  ${_typography.typographyH3};
  ${_typography.typographyH4};
  ${_typography.typographyH5};
  ${_typography.typographyH6};
  ${_typography.typographyTextParagraph};
  ${_typography.typographyTextSupport};
  ${_typography.typographyTextSupportForm};
  ${_typography.typographyLabelForm};
  ${_typography.typographyLabelButton};
  ${_typography.typographyLabelAction};
  ${_typography.typographyTitle};
  ${_typography.typographySubtitle1};
  ${_typography.typographySubtitle2};
  ${_typography.typographyBody1};
  ${_typography.typographyBody2};
  ${_customizations.typographyDisplay};
  ${_customizations.typographyWeight};
  ${_customizations.typographyColor};
  ${_customizations.typographyGutterBottom};
`;
exports.Typography = Typography;